import { SIGNATORY_CREATE } from 'common-app/api/query/signatory-create';
import { SIGNATORY_READ } from 'common-app/api/query/signatory-read';
import { SIGNATORY_WRITE } from 'common-app/api/query/signatory-write';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { getSignatory, newSignatory, setSignatory } from './data';
export default [
    {
        request: {
            query: SIGNATORY_READ,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: {
            data: {
                read_signatory: getSignatory().map((p) => (Object.assign(Object.assign({}, p), { __typename: 'SignatoryDto' }))),
            },
        },
    },
    {
        request: {
            query: SIGNATORY_CREATE,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: {
            data: {
                create_signatory: Object.assign(Object.assign({}, newSignatory()), { __typename: 'SignatoryDto' }),
            },
        },
    },
    {
        request: {
            query: SIGNATORY_WRITE,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: (variables) => {
            const signatory = variables === null || variables === void 0 ? void 0 : variables.participants;
            setSignatory(signatory);
            return {
                data: {
                    write_signatory: signatory.map((p) => (Object.assign(Object.assign({}, p), { __typename: 'SignatoryDto' }))),
                },
            };
        },
    },
];
